import { SalaryIncreasePlaceholder } from "../components/SalaryIncreasePlaceholder";

export default function SageSubmissionPage() {
  return (
    <SalaryIncreasePlaceholder
      title="Sage 300 Submission"
      description="Submit approved increases to Sage 300 payroll."
    />
  );
}
